module.exports = __webpack_public_path__ + "static/full-ed9c1639098df7a9826519f358de124b.mp4";